import is from '@sindresorhus/is';

// Stamp width (14) + stamp-to-label gap (6) + horizontal cell padding (24).
const STATUS_CELL_OVERHEAD_PX = 14 + 6 + 24;
const STATUS_LABEL_FONT = '500 14px Inter, ui-sans-serif, system-ui, sans-serif';

const measureLabelWidth = (label: string, font: string): number => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (is.null(ctx)) {
        return 0;
    }
    ctx.font = font;
    return ctx.measureText(label).width;
};

// Sizes the status column to its widest possible label so the grid does not reflow
// as the row labels change between draft/review/publish states.
export const computeStatusColumnWidth = (labels: readonly string[]): number => {
    let max = 0;
    for (const label of labels) {
        const w = measureLabelWidth(label, STATUS_LABEL_FONT);
        if (w > max) {
            max = w;
        }
    }
    return Math.ceil(max + STATUS_CELL_OVERHEAD_PX);
};
